var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenSl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 300 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10 9 56 0 150 0C244 0 290 9 290 9L300 21C300 21 246 14 150 14C54 14 0 21 0 21L10 9Z",
    fill: "#1f1c3c"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_780_4378",
    x1: 147.916,
    y1: 2.5,
    x2: 147.916,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4307D",
    className: "svg_stop"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    className: "svg_start",
    stopColor: "#D4307D",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    className: "svg_end",
    stopColor: "#212027",
    stopOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenSl);
export default __webpack_public_path__ + "static/media/screen-sl.b277aee7.svg";
export { ForwardRef as ReactComponent };